// extracted by mini-css-extract-plugin
export default {"dangerModal":"useDistributionsController_dangerModal__92PVT"};